const REPORT_FILTERS_KEYS = {
  PROVIDER: 'PROVIDER',
  BRAND: 'BRAND',
  ORDER_TYPE: 'ORDER_TYPE',
  STORE_PAYMENT_TYPE: 'STORE_PAYMENT_TYPE',
  USER_PAYMENT: 'USER_PAYMENT',
  USER_ORDER: 'USER_ORDER',
  USER_CANCELED: 'USER_CANCELED',
  USER_AUTHORIZED: 'USER_AUTHORIZED',
} as const;

export { REPORT_FILTERS_KEYS };
